import { Link } from "react-router-dom";
import SectionHeading from "./SectionHeading";
import MetaServiceCard from "./MetaServiceCard";
import EnterpriseServiceGrid from "./EnterpriseServiceGrid";
import IndustryTabbedView from "./IndustryTabbedView";

function ServicesSection() {
  return (
    <section className="section services-section" id="services">
      <div className="container">
        <SectionHeading
          eyebrow="What We Do"
          title="Our Services"
          subtitle="From flagship Meta integrations to enterprise software and industry-specific platforms — we build technology that moves your business forward."
        />

        <div className="reveal">
          <MetaServiceCard />
        </div>

        <div className="services-block reveal">
          <div className="services-block__head">
            <span className="eyebrow">Enterprise Software</span>
            <h3 className="services-block__title">
              Enterprise Core Systems & Business Software
            </h3>
            <p className="services-block__sub">
              Robust, secure and scalable platforms that automate your core
              operations and give leadership real-time visibility.
            </p>
          </div>
          <EnterpriseServiceGrid />
        </div>

        <div className="services-block reveal">
          <div className="services-block__head">
            <span className="eyebrow">Industry Expertise</span>
            <h3 className="services-block__title">
              Specialized Industry Solutions
            </h3>
            <p className="services-block__sub">
              Deeply tailored software built around the way your industry
              actually works — choose your sector to explore our capabilities.
            </p>
          </div>
          <IndustryTabbedView />
        </div>

        <div className="services-cta reveal">
          <div>
            <h3 className="services-cta__title">Ready to build with us?</h3>
            <p className="services-cta__text">
              Get a detailed quotation or book a live demo with our solution
              architects — we respond within one business day.
            </p>
          </div>
          <div className="services-cta__actions">
            <Link className="btn btn--primary" to="/contact">
              Request a Quote
              <i className="bi bi-arrow-right" />
            </Link>
            <Link className="btn btn--ghost" to="/contact">
              <i className="bi bi-calendar3" />
              Book a Demo
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;
